/**
 * Whether to remember the state of each panel before leaving the page.
 * @param  {object} widget The accordion instance to save state
 * @return {object} The destroy method to remove everything create by the module
 */
function saveState(widget) {
  /**
   * initialize event listener and try to restore previous state if it exists.
   */
  function init() {
    window.addEventListener('beforeunload', onBeforeUnload, false);
    restore();
  }

  /**
   * Saves the current open/close state of each items before the page gets
   * unloaded
   */
  function onBeforeUnload() {
    save();
  }

  /**
   * Saves the current open/close state of each items in localStorage
   */
  function save() {
    $.storage.local.set(
      widget.guid,
      widget.items.map(function () {
        return this.open ? 1 : 0;
      })
    );
  }

  /**
   * Restores the state of each items (open or close) from localStorage
   */
  function restore() {
    const items = $.storage.local.get(widget.guid);
    if (items === null) {
      return;
    }
    items.forEach(function (open, index) {
      if (+open === 1) {
        widget.open(index);
      }
    });
  }

  /**
   * Remove the storage entry and remove the event listener
   */
  function destroy() {
    $.storage.local.remove(widget.guid);
    window.removeEventListener('beforeunload', onBeforeUnload, false);
  }

  init();

  return {
    destroy
  };
}

saveState.id = 'saveState';

export default saveState;
